import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';

const AddUser = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    firstName: '',
    lastName: '',
    emailAddress: '',
    cellNumber: '',
    userRoleType: '',
    agencyName: ''
  });
  const [roleTypes, setRoleTypes] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchRoleTypes();
    fetchAgencies();
  }, []);

  const fetchRoleTypes = async () => {
    try {
      const data = await apiService.get('/user-role-types');
      setRoleTypes(data);
    } catch (err) {
      console.error('Error fetching role types:', err);
      setError('Failed to load role types');
    } finally {
      setLoading(false);
    }
  };

  const fetchAgencies = async () => {
    try {
      const data = await apiService.get('/agencies');
      setAgencies(data);
    } catch (err) {
      console.error('Error fetching agencies:', err);
    }
  };

  const handleInputChange = (field, value) => {
    setUserData({
      ...userData,
      [field]: value
    });
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      
      // Find the selected role type ID
      const selectedRoleType = roleTypes.find(role => 
        (role.title || role.name) === userData.userRoleType
      );
      
      // Find the selected agency ID
      const selectedAgency = agencies.find(agency => 
        agency.agencyName === userData.agencyName
      );

      const requestBody = {
        editedBy: 3,
        userRoleTypeId: selectedRoleType ? selectedRoleType.id : 0,
        agencyId: selectedAgency ? selectedAgency.id : 0,
        sellerCompanyId: 1,
        firstName: userData.firstName || "",
        lastName: userData.lastName || "",
        emailAddress: userData.emailAddress || "",
        cellNumber: userData.cellNumber || "",
        notes: ""
      };

      const result = await apiService.post('/users', requestBody);
      console.log('User created successfully:', result);
      
      alert('User created successfully!');
      
      // Navigate back to manage users or clear the form
      navigate('/manage-users');
      
    } catch (err) {
      console.error('Error creating user:', err);
      alert('Failed to create user. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Add User</h1>
        </div>
        <div className="loading-state">
          <p>Loading form data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Add User</h1>
        </div>
        <div className="error-state">
          <p>{error}</p>
          <button onClick={fetchRoleTypes} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="manage-properties">
      <div className="page-header">
        <h1>Add User</h1>
      </div>

      <div className="content-container">
        <div className="form-section">
          <h3>Personal Information</h3>
          <div className="form-grid">
            <div className="form-row">
              <label htmlFor="firstName">First Name:</label>
              <input
                type="text"
                id="firstName"
                className="form-input"
                value={userData.firstName}
                onChange={(e) => handleInputChange('firstName', e.target.value)}
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="lastName">Last Name:</label>
              <input
                type="text"
                id="lastName"
                className="form-input"
                value={userData.lastName}
                onChange={(e) => handleInputChange('lastName', e.target.value)}
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="emailAddress">Email Address:</label>
              <input
                type="email"
                id="emailAddress"
                className="form-input"
                value={userData.emailAddress}
                onChange={(e) => handleInputChange('emailAddress', e.target.value)}
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="cellNumber">Cell Number:</label>
              <input
                type="text"
                id="cellNumber"
                className="form-input"
                value={userData.cellNumber}
                onChange={(e) => handleInputChange('cellNumber', e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>User Role & Agency</h3>
          <div className="form-grid">
            <div className="form-row">
              <label htmlFor="roleType">Role Type:</label>
              <select 
                id="roleType"
                className="form-select"
                value={userData.userRoleType}
                onChange={(e) => handleInputChange('userRoleType', e.target.value)}
              >
                <option value="">Select a role type</option>
                {roleTypes.map((role) => (
                  <option key={role.id} value={role.title || role.name}>
                    {role.title || role.name}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="form-row">
              <label htmlFor="agencyName">Agency:</label>
              <select 
                id="agencyName"
                className="form-select"
                value={userData.agencyName}
                onChange={(e) => handleInputChange('agencyName', e.target.value)}
                disabled={userData.userRoleType !== 'Agent'}
              >
                <option value="">Select an agency</option>
                {agencies.map((agency) => (
                  <option key={agency.id} value={agency.agencyName}>
                    {agency.agencyName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button 
            type="button" 
            className="btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? 'Creating...' : 'Create User'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
